import axiosInstance from 'api/axiosInstance';

const API_URL = '/api2.0/tickets/toggleTicketVoidStatus';

export const toggleTicketVoidStatus = async (
	ticketNumber: string,
): Promise<void> => {
	try {
		await axiosInstance.post(API_URL, { ticketNumber });
	} catch (error) {
		console.error(
			`❌ Error in toggleTicketVoidStatus for ticket #${ticketNumber}:`,
			error,
		);
		throw error;
	}
};
